import Icon from "@/components/Ui/Icon";
import { Vendor, useVendorContext } from "@/contexts/vendor-context";
import { getImgProxyUrl } from "@/utils/image-proxy";

type Props = {
  vendor: Vendor | undefined;
};

const VendorCard = ({ vendor }: Props) => {
  const { multiVendorKey } = useVendorContext();
  const { name, vendorId, logo } = vendor || {};

  if (!vendor) return null;
  const vendorMainPage =
    vendor.vendorId === multiVendorKey
      ? `/${vendorId}`
      : `/${vendorId}/analytics`;
  return (
    <a
      href={vendorMainPage}
      className="bg-card row hover:border-interact-border hover:bg-interact-card w-full space-x-3 rounded border p-3 transition-colors active:translate-y-px md:p-4"
    >
      <span className="row relative aspect-square w-[34px] overflow-hidden rounded-sm bg-white">
        {logo && (
          <img
            className="w-full p-0.5"
            src={getImgProxyUrl(logo, ["rs:fill:64:0"])}
            alt={`${name}'s logotype`}
          />
        )}
        {!logo && <Icon name="sesamy-simple" className="text-xl text-black" />}
      </span>
      <span className="column-left flex flex-1 items-start space-y-1 text-left">
        <span className="text-base leading-none tracking-wide first-letter:uppercase">
          {name || vendorId}
        </span>
      </span>
      <span className="row aspect-square w-10 rounded">
        <Icon name="chevron-right" />
      </span>
    </a>
  );
};

export default VendorCard;
